// LazyImage.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import WithIntersectionObserver from '../component/WithIntersectionObserver.jsx';

class LazyImage extends React.PureComponent {
  state = { isIntersected: false };

  // TODO: this function is just for unit test, should refactor later.
  handleChange = ({ isIntersected }) => {
    const { isIntersected: prevIsIntersected } = this.state;
    return this.setState({ isIntersected: prevIsIntersected || isIntersected });
  };

  reduceSource = (acc, child, idx) => {
    if (child.type !== 'source') {
      return acc;
    }

    const newProps = {
      ...child.props,
      key: idx,
    };

    return acc.concat([React.createElement('source', newProps)]);
  };

  render() {
    const { isIntersected: stateIsIntersected } = this.state;
    const { threshold, rootMargin, children, ...restProps } = this.props;
    const childArray = React.Children.toArray(children);

    return (
      <WithIntersectionObserver
        threshold={threshold}
        rootMargin={rootMargin}
        onChange={this.handleChange}
      >
        {({ isIntersected }) => {
          return stateIsIntersected || isIntersected ? (
            <Picture>
              {childArray.reduce(this.reduceSource, [])}
              <Image {...restProps} draggable="false" />
            </Picture>
          ) : (
            <Empty />
          );
        }}
      </WithIntersectionObserver>
    );
  }
}

LazyImage.propTypes = {
  children: PropTypes.node,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  rootMargin: PropTypes.string,
};

LazyImage.defaultProps = {
  children: null,
  threshold: 1.0,
  rootMargin: '0px',
};

const Picture = styled.picture`
  display: block;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`;

Image.displayName = 'Image'; // for LazyImage.test.js component finding

const Empty = styled.div`
  width: 100%;
  height: 100%;
`;

export default LazyImage;
